export default __webpack_public_path__ + "static/media/logo.776b26d9.png";